// ConceptLanguageProvider.tsx
import React, { useState } from 'react';
import type { DeliveryLanguage } from 'types/next';

interface ConceptLanguageContextType {
  language: DeliveryLanguage;
  setLanguage: (lang: DeliveryLanguage) => void;
}

export const ConceptLanguageContext = React.createContext<ConceptLanguageContextType | undefined>(undefined);

export const ConceptLanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [language, setLanguage] = useState<DeliveryLanguage>('fi');

  const updateLanguage = (lang: DeliveryLanguage) => {
    setLanguage(lang);
  };

  return (
    <ConceptLanguageContext.Provider value={{ language, setLanguage: updateLanguage }}>
      {children}
    </ConceptLanguageContext.Provider>
  );
};
